var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    clipPath: "url(#clip0_1_59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 8.04748C16 3.71263 12.5075 0.19873 8.19997 0.19873C3.89047 0.199705 0.398018 3.71263 0.398018 8.04846C0.398018 11.965 3.25087 15.2118 6.97927 15.8007V10.3163H5.00002V8.04846H6.98122V6.31783C6.98122 4.35126 8.14634 3.26511 9.92767 3.26511C10.7818 3.26511 11.6739 3.41818 11.6739 3.41818V5.34868H10.6901C9.72194 5.34868 9.41969 5.95415 9.41969 6.57523V8.04748H11.5822L11.2371 10.3153H9.41872V15.7997C13.1471 15.2108 16 11.9641 16 8.04748Z",
    fill: "#091F92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6,
    height: 15.6,
    fill: "white",
    transform: "translate(0.400002 0.199951)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6ea971024362e4cc1366be69ef848e12.svg";
export { ForwardRef as ReactComponent };